import React from 'react';
import { Icon } from '../../common/components/Utilities';
import PeopleLayout from '../layout/PeopleLayout';
import DataTable from '../../common/components/DataTable';
import LargeUserPill from '../../common/components/LargeUserPill';

function HealthAndSafetyPage(props) {
  return <PeopleLayout {...props} content={<HealthAndSafetyShow {...props} />} />;
}

function HealthAndSafetyShow({ groups }) {
  const renderRow = (user) => (
    <tr>
      <td><LargeUserPill user={user} /></td>
      <td style={{ verticalAlign: 'middle' }}>{user.squad.name}</td>
    </tr>
  );

  const firstAiders = (
    <>
      <Icon icon="medkit" append="mr-2 text-success" />
      {' '}
      First Aiders
    </>
  );

  const mhFirstAiders = (
    <>
      <Icon icon="head-side-medical" append="mr-2 text-success" />
      {' '}
      Mental Health First Aiders
    </>
  );

  const fireMarshals = (
    <>
      <Icon icon="fire-extinguisher" append="mr-2 text-success" />
      {' '}
      Fire Marshals
    </>
  );

  return (
    <>
      <div className="mb-4">
        <DataTable url="/resource/users" title={firstAiders} filters={{ group_id: groups.FIRST_AID }} columns={['Person', 'Squad']} renderRow={renderRow} />
      </div>
      <div className="mb-4">
        <DataTable url="/resource/users" title={mhFirstAiders} filters={{ group_id: groups.MENTAL_HEALTH_FIRST_AID }} columns={['Person', 'Squad']} renderRow={renderRow} />
      </div>
      <div className="mb-4">
        <DataTable url="/resource/users" title={fireMarshals} filters={{ group_id: groups.FIRE_MARSHAL }} columns={['Person', 'Squad']} renderRow={renderRow} />
      </div>
    </>
  );
}

export default HealthAndSafetyPage;
